import React from "react";
import { Credentials, login } from "../ApiService";
import LoginModule from "../modules/LoginModule/LoginModule";

const LoginPage: React.FC = () => {
  const credentials: Credentials = {
    email: process.env.NODE_ENV === "development" ? "test@example.com" : "",
    password: process.env.NODE_ENV === "development" ? "example" : "",
  };

  const handleSubmit = (credentials: Credentials) => {
    const loginAllowed = credentials.email && credentials.password;
    if (loginAllowed) {
      login(credentials)
        .then((token) => {
          localStorage.setItem("jwt", token.access_token);
          window.location.replace("/stores");
        })
        .catch((error) => {
          console.error("Ошибка авторизации:", error);
        });
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-200">
      <LoginModule
        title="Вход"
        credentials={credentials}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
export default LoginPage;
